// extracted by mini-css-extract-plugin
export default {"qu-bigmultitext":"site_qu-bigmultitext__FMk4u","qu-userforename":"site_qu-userforename__iIjdK","qu-userfamilyname":"site_qu-userfamilyname__ASoe9"};